
import { COLOR_OPTION_INTERFACE } from "../pages/Setting/interface"
import { COLOR_OPTION } from "./common"
import { getImageUrl } from "./Funcation"

export const getTheme = (THEME: string) => {
    const theme = COLOR_OPTION.find((_: COLOR_OPTION_INTERFACE) => _.value === THEME)
    return theme
    // COLOR_OPTION
}

/** Header Schema from admin: hex stays solid; CSS gradients use background. */
export const styleObjectGetHeaderSchema = (headerSchema?: string) => {
    if (!headerSchema) return {}
    const value = headerSchema.trim().replace(/;+\s*$/, "")
    if (!value) return {}
    if (/gradient\s*\(/i.test(value)) {
        return { background: value }
    }
    return { backgroundColor: value }
}

export const styleObjectGetBG = (theme: string, isBorder: boolean = false, Color: boolean = false) => {
    let obj: any = {
        background: getTheme(theme)?.backgroundColor,
    }
    if (isBorder) {
        obj.border = `1px solid ${getTheme(theme)?.backgroundColor}`
    }
    if (Color) {
        obj.color = getTheme(theme)?.color
    }
    return obj
}
export const styleObjectGetColor = (theme: string,) => {
    let obj: any = {
        color: getTheme(theme)?.color,
    }
    return obj
}

export const styleObjectBlackButton = (theme: string, Hover: boolean) => {
    let obj = {
        color: Hover ? getTheme(theme)?.color : getTheme(theme)?.backgroundColor,
        border: `1px solid ${getTheme(theme)?.backgroundColor}`,
        background: Hover ? getTheme(theme)?.backgroundColor : getTheme(theme)?.color
    }
    return obj
}

export const styleObjectWhiteButton = (theme: string, Hover: boolean) => {
    let obj = {
        color: Hover ? getTheme(theme)?.color : 'black',
        // border: `1px solid ${getTheme(theme)?.backgroundColor}`,
        background: Hover ? getTheme(theme)?.backgroundColor : 'white'
    }
    return obj
}

export const styleObjectGetBGIMageLoginImage = (path: string) => {
    let obj = {
        backgroundImage: `url(${getImageUrl(path)})`
    }
    return obj
}
export const styleObjectGetLoginImage = (path: string) => {
    let obj = {
        backgroundImage: `url(${getImageUrl(path)})`
    }
    return obj
}
export const styleObjectGetBGasColor = (theme: string, borderColor = false, headerTextColor = false) => {
    let obj: any = {
        color: getTheme(theme)?.backgroundColor,
    }
    if (borderColor) {
        obj.borderColor = getTheme(theme)?.backgroundColor;
    }
    if (headerTextColor) {
        obj.color = getTheme(theme)?.headerTextColor;
    }

    return obj
}
export const styleObjectGetBorderColor = (theme: string, headerTextColor = false, dynamicBorderColor?: string) => {
    let obj = {
        borderColor: getTheme(theme)?.backgroundColor,
    }
    if (dynamicBorderColor && dynamicBorderColor !== "") {
        obj.borderColor = trimLoginCss(dynamicBorderColor);
        return obj;
    }
    if (headerTextColor) {
        obj.borderColor = getTheme(theme)?.headerTextColor === getTheme(theme)?.backgroundColor ? getTheme(theme)?.color : getTheme(theme)?.headerTextColor;
    }
    return obj
}

export const loginBackGroundColor = (theme: string, isButton = false) => {
    let obj: any = {
        background: `${getTheme(theme)?.login.background}`,
        // background: getTheme(theme)?.login.background,   
    }

    if (isButton) {
        obj = {
            color: getTheme(theme)?.login.logginButtonColor,
        }
    }
    // if (isBorder) {
    //     obj.border = `1px solid ${getTheme(theme)?.backgroundColor}`
    // }
    // if (Color) {
    //     obj.color = getTheme(theme)?.color
    // }
    return obj
}

export const loginPolicyTextColor = (theme: string) => {
    let obj: any = {
        color: getTheme(theme)?.login.color,
    }

    return obj
}

export const trimLoginCss = (value?: string) =>
    String(value || "").trim().replace(/;+\s*$/, "")

function firstHexFromCss(value: string): string {
    const hex = String(value).match(/#([0-9a-f]{3,8})/i)
    if (hex) {
        let raw = hex[1]
        if (raw.length === 3) raw = raw.split("").map((c) => c + c).join("")
        return `#${raw.slice(0, 6)}`
    }
    const rgb = String(value).match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i)
    if (rgb) {
        const toHex = (n: string) => Number(n).toString(16).padStart(2, "0")
        return `#${toHex(rgb[1])}${toHex(rgb[2])}${toHex(rgb[3])}`
    }
    return ""
}

function isLightCssColor(value: string): boolean {
    const hex = firstHexFromCss(value)
    if (!hex) return /white|#fff/i.test(String(value))
    const clean = hex.replace("#", "")
    const r = parseInt(clean.substring(0, 2), 16)
    const g = parseInt(clean.substring(2, 4), 16)
    const b = parseInt(clean.substring(4, 6), 16)
    return (r * 299 + g * 587 + b * 114) / 1000 >= 128
}

/** CSS variables for the mobile login page. Blank admin fields keep the current theme look. */
export const getLoginPageCssVars = (DD: any): Record<string, string> => {
    const theme = getTheme(DD?.colorSchema)
    const pageBg = trimLoginCss(DD?.loginPageBgColor) || String(theme?.login?.background || "")
    const buttonBg = trimLoginCss(DD?.loginButtonColor)
    const buttonText =
        trimLoginCss(DD?.loginButtonTextColor) || String(theme?.login?.logginButtonColor || "")
    const footerLink =
        trimLoginCss(DD?.loginFooterLinkColor) || String(theme?.login?.color || "")
    const supportBg = trimLoginCss(DD?.loginSupportColor)
    const downloadBg = trimLoginCss(DD?.loginDownloadButtonColor)

    const vars: Record<string, string> = {}
    if (pageBg) vars["--login-page-bg"] = pageBg
    if (buttonBg) vars["--login-button-bg"] = buttonBg
    if (buttonText) vars["--login-button-text"] = buttonText
    if (footerLink) vars["--login-footer-link-color"] = footerLink
    if (supportBg) vars["--login-support-bg"] = supportBg
    // Sky support footer keeps its designed colors unless this website saved its own values.
    const customFooterLink = trimLoginCss(DD?.loginFooterLinkColor)
    if (customFooterLink) vars["--login-skysupport-link"] = customFooterLink
    if (supportBg) vars["--login-skysupport-bg"] = supportBg
    if (downloadBg) vars["--login-download-bg"] = downloadBg
    const customButtonText = trimLoginCss(DD?.loginButtonTextColor)
    if (customButtonText) vars["--login-download-text"] = customButtonText
    const iconOnLight = !supportBg || isLightCssColor(supportBg)
    vars["--login-support-icon-filter"] = iconOnLight ? "brightness(0)" : "none"
    return vars
}

/** Theme color for Bets, Balance, Exposure and the settings icon when the site saved no text color. */
export const getHeaderAccountThemeTextColor = (DD: any) => {
    const theme = getTheme(DD?.colorSchema)
    return String(theme?.headerTextColor || theme?.backgroundColor || "")
}

/** Saved text color for those buttons, or the theme color when the site left it blank. */
export const getHeaderAccountButtonTextColor = (DD: any) =>
    trimLoginCss(DD?.headerAccountButtonTextColor) || getHeaderAccountThemeTextColor(DD)

/** Present only when this site saved its own text color, so the default theme color stays in place. */
export const getHeaderAccountButtonTextClass = (DD: any) =>
    trimLoginCss(DD?.headerAccountButtonTextColor) ? "has-custom-account-btn-text" : ""

/** Logged-in header Bets, Balance, Exposure and settings button.
 *  Blank background keeps the original gray. Blank text keeps the theme color.
 *  A saved value for this site replaces that default. */
export const getHeaderAccountButtonStyle = (
    DD: any
): Record<string, string> | undefined => {
    const bg = trimLoginCss(DD?.headerAccountButtonColor)
    const color = trimLoginCss(DD?.headerAccountButtonTextColor)
    const style: Record<string, string> = {}

    if (bg) style["--header-account-btn-bg"] = bg
    if (color) style["--header-account-btn-text"] = color

    return Object.keys(style).length ? style : undefined
}


/** Mobile sports Place Bet button. Blank admin fields keep the current look. */
export const getPlaceBetButtonStyle = (DD: any) => {
    const bg = trimLoginCss(DD?.placeBetButtonColor)
    const text = trimLoginCss(DD?.placeBetButtonTextColor)
    const style: Record<string, string> = {}
    if (bg) {
        style["--place-bet-button-bg"] = bg
        style.background = bg
        if (!/gradient\s*\(/i.test(bg)) {
            style.borderColor = bg
        }
    }
    if (text) {
        style["--place-bet-button-text"] = text
        style.color = text
    }
    return style
}

/** Mobile header Login button. Blank keeps the original red gradient for this website. */
const isMobileLoginGradient = (value: string) =>
    /^(repeating-)?(linear|radial|conic)-gradient\(/i.test(value)

const isMobileLoginColor = (value: string) =>
    /^(#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})|(rgb|hsl)a?\([^)]*\)|[a-z]{3,20})$/i.test(value)

export const getMobileLoginButtonStyle = (value?: string) => {
    const color = String(value || "").trim().replace(/;+\s*$/, "")
    if (!color) return undefined
    if (isMobileLoginGradient(color)) {
        return {
            ["--mobile-login-button-bg" as string]: "transparent",
            ["--mobile-login-button-image" as string]: color,
        }
    }
    if (!isMobileLoginColor(color)) return undefined
    return {
        ["--mobile-login-button-bg" as string]: color,
        ["--mobile-login-button-image" as string]: "none",
    }
}

export const getMobileLoginButtonClassName = (value?: string) => {
    return getMobileLoginButtonStyle(value)
        ? "btn-login has-custom-mobile-login"
        : "btn-login"
}

export const getPlaceBetButtonClassNames = (DD: any) => {
    const classes: string[] = []
    if (trimLoginCss(DD?.placeBetButtonColor)) classes.push("has-custom-place-bet-bg")
    if (trimLoginCss(DD?.placeBetButtonTextColor)) classes.push("has-custom-place-bet-text")
    return classes.join(" ")
}